import React from 'react';
import sty from 'styled-components'
import { Link } from 'react-router-dom';
import Destaques from '@material-ui/icons/StarsRounded'
import Novidades from '@material-ui/icons/Timelapse'
import Categorias from '@material-ui/icons/Widgets'
import BackIcon from '@material-ui/icons/ArrowBackRounded'

import logo from '../assets/logo.png';

import m from '../services/media';


export default function (p){
  return (
    <Container>
      <Header>
        <Backdrop back={p.back}/>
        {p.back ? <Back style={{marginRight: '1rem'}} onClick={p.history.goBack}>
          <BackIcon/>
        </Back> : null}
        <LogoBrand>
          <Link to='/'>
            <LogoContainer back={p.back}>
              <Logo src={logo}/>
            </LogoContainer>
          </Link>
          <BrandContainer>
            <Brand>
              Região Tv
            </Brand>
          </BrandContainer>
        </LogoBrand>
      </Header>
      <Content>
        {p.children}
      </Content>
      <Footer/>
    </Container>
  );
}

const Container = sty.div`
height: 100vh;
width: 100vw;
display: flex;
flex-direction: column;
`
const Header = sty.div`
height: 5rem;
width: 100%;
padding: 0 1rem 1rem 1rem;
position: fixed;
z-index: 10;
align-items: center;
`
const Backdrop = sty.div`
  backdrop-filter: blur(8px);
  background-image: linear-gradient(#fffd, #fff8);
  position: absolute;
  height: ${(p)=>p.back? '4rem':'2.8rem'};
  border-radius: 0 0 .5rem .5rem;
  top: 0;
  left: 0;
  right:0;
  z-index: -1
`
const LogoBrand = sty.div`
align-items: center
`
const LogoContainer = sty.div`
width: ${(p)=>p.back? '2.3rem':'3.2rem'};
height: ${(p)=>p.back? '2.3rem':'3.2rem'};
flex: 0 0 3.5rem;
border-radius: 50%;
justify-content: center;
align-items: center;
box-shadow:  ${(p)=>p.back? '':'0 .1rem .3rem #8884'};
background-color: #fff;
`
const Logo = sty.img`
height: 70%;
`
const BrandContainer = sty.div`
margin: 1rem 0 1rem -2.7rem;
box-shadow: 0 .1rem .3rem #8884;
border-radius: 4rem 4rem 4rem 4rem;
padding: .3rem 1rem .25rem 3rem;
background-color: #fff;
z-index: -1;
display: flex;
`
const Brand = sty.h1`
margin: 0;
color: #333;
font-size: 1.2rem;
padding: .2rem
font-family: 'Raleway', sans-serif;
font-weight: 600;
white-space: nowrap;
overflow: hidden;
`
const Control = sty.div`
margin: .1rem auto 0 .5rem;
overflow-x: scroll;
`
const Section = sty.div`
background-color: white;
margin: .3rem;
height: 2.5rem;
border-radius: 2.5rem;
box-shadow: 0 .1rem .3rem #8884;
padding: .5rem;
height: 100%;
align-items: center;
${m.sm`
  &:hover h1 {
    display: none;
  }
`};
${m.md`
  &:hover h1 {
    display: flex;
  }
`};

`
const SectionIcon = sty.div`
color: #1a59d7;
`
const SectionText = sty.h1`
margin: 0 .2rem 0 .3rem;
font-family: 'Raleway', sans-serif;
font-size: 1.2rem;
font-weight: 300;
display: none;
${m.md`
  font-size: 1rem;
  display: flex;
`};
${m.lg`
  display: flex;
`};
`
const User = sty.img`
margin: .1rem 0 0 .5rem;
height: 36px;
width: 36px;
border-radius: 50%;
box-shadow: 0 .1rem .3rem #8884;
border-width: 2px;
border-style: solid;
border-color: #fff
`
const Content = sty.div`
flex-direction: column
flex: 1 0;
width: 100%;
height: 100%;
`
const Footer = sty.div`

`
const Back = sty.div`
`